import React from "react";
import { StyleSheet } from "react-native";

import ReportJournal from "./ReportJournal";
import ReportCommentIcon from "../list/ReportCommentIcon";

export default function ReportOverallComment({
  controller,
  report = {},
  hideCommentsIcon = false,
}) {
  const isAggregated = Array.isArray(report.mood);
  const overallItems = [];
  if (isAggregated) {
    Object.keys(report.mood).forEach((k) => {
      overallItems.push({
        name: "Overall Comment (" + report.user_nickname[k] + ")",
        mood: report.mood[k] || 5,
        datetime_created: report.datetime_updated,
        text: report.comment[k],
      });
    });
  } else {
    overallItems.push({
      name: "Overall Comment",
      mood: report.mood || 5,
      datetime_created: report.datetime_updated,
      text: report.comment,
    });
  }

  return (
    <>
      {isAggregated ? (
        overallItems.map((item) => <ReportJournal journal={item} />)
      ) : (
        <ReportJournal journal={overallItems[0]} />
      )}

      {hideCommentsIcon ? null : (
        <ReportCommentIcon
          styles={styles.reportIcon}
          report={report}
          controller={controller}
        />
      )}
    </>
  );
}

const styles = StyleSheet.create({
  reportIcon: {
    position: "absolute",
    top: 16,
    right: 10,
  },
});
